import service from '.'
import {
  toast
} from '../util/decorators'
import api from './api'
import BaseService from './BaseService'

export default class OtherService extends BaseService {
  constructor() {
    super({
      setting: {
        prayerSupport: {},
        index_menu: [],
        index_ad: {}
      },
      banner: [],
      recommendations: []
    })
  }

  get setting() {
    return this.data.setting
  }

  get banner() {
    return this.data.banner
  }

  get prayer() {
    return service.user.getPrayer() !== this.data.setting.prayerSupport.dateline
  }

  get recommendations() {
    return this.data.recommendations
  }

  @toast()
  async loadSetting() {
    this.data.setting = await api.other.getSetting()
  }

  @toast()
  async loadBanners() {
    this.data.banner = await api.other.getBanners({
      pagesize: 6
    })
  }

  @toast()
  async loadHomeRecommendations() {
    this.data.recommendations = await api.category.getRecommendations()
  }

  @toast()
  async sendSuggest({
    content,
    contact
  }) {
    return await api.other.feedback({
      content,
      contact
    })
  }

  @toast()
  async getPrayerSupport() {
    return await api.other.getPrayerSupport({
      nohtml: 0
    })
  }

  @toast()
  async loadAbout() {
    return await api.other.getAbout({
      nohtml: 0
    })
  }

  async getPay() {
    return await api.other.getPaySetting()
  }

  goItem(item, router) {
    if (item.target === 'webview' || item.target === 'browser') {
      window.location.href = item.linkurl
    } else if (item.target === 'movie') {
      let route = {
        name: 'movie',
        params: {
          movid: item.movid
        }
      }
      if (item.urlid) {
        route.query = {
          urlid: item.urlid
        }
      }
      router.push(route)
    } else if (item.target === 'category') {
      router.push({
        name: 'bookshelf',
        params: {
          catid: item.catid
        },
        query: {
          catname: item.name
        }
      })
    } else if (item.target === 'activity') {
      switch (item.page) {
        case 'update':
          return router.push({
            name: 'latest',
            query: {
              recmd: 2,
              name: '最近更新'
            }
          })
        case 'actor':
          return router.push({
            name: 'category-priest'
          })
        case 'recommend':
          return router.push({
            name: 'bookshelf',
            query: {
              recmd: 3,
              name: '推荐视频'
            }
          })
        case 'hot':
          return router.push({
            name: 'bookshelf',
            query: {
              recmd: 1,
              name: '热门视频'
            }
          })
        case 'bible':
          return router.push({
            name: 'bible'
          })
      }
    } else if (item.target === 'miniprogram') {
      window.location.href = item.url
    }
  }
}



// WEBPACK FOOTER //
// ./src/service/OtherService.js